import { render } from "./long-insure-bills.vue?vue&type=template&id=6b910e45&scoped=true&ts=true"
import script from "./long-insure-bills.vue?vue&type=script&lang=ts"
export * from "./long-insure-bills.vue?vue&type=script&lang=ts"

import "./long-insure-bills.vue?vue&type=style&index=0&id=6b910e45&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b910e45"]])

export default __exports__